import {
  ApiEnvelope,
  LoginResponse,
  SendCodeResponse,
  SignupCheckResponse,
  VerifyCodeResponse,
} from 'types/api';
import { http } from '.';

export const postSendCode = async (payload: { phone: string; countryCode: string }) => {
  const response = await http.post<ApiEnvelope<SendCodeResponse>>('/users/auth-code/send', payload);
  return response;
};

export const postVerifyCode = async (payload: { phone: string; authCode: string }) => {
  const response = await http.post<VerifyCodeResponse>('/users/auth-code/verify', payload);
  return response;
};

export const postSignupCheck = async (payload: { phone: string }) => {
  const response = await http.post<SignupCheckResponse>('/users/signup/check', payload);
  return response;
};

export const postLogin = async (payload: {
  shopSeqNo: number;
  phone: string;
  password: string;
  countryCode: string;
}) => {
  const response = await http.post<ApiEnvelope<LoginResponse>>('/users/signup/login', payload);

  return response.data;
};

export const postRegister = async (payload: {
  shopSeqNo: number;
  phone: string;
  countryCode: string;
  password: string;
}) => {
  const response = await http.post<ApiEnvelope<LoginResponse>>('/users/signup/register', payload);
  return response.data;
};

export const postResetPassword = async (payload: {
  shopSeqNo: number;
  phone: string;
  countryCode: string;
  newPassword: string;
}) => {
  const response = await http.post<ApiEnvelope<{ message: string }>>(
    '/users/signup/reset-password',
    payload,
  );
  return response;
};

export const postSignupPhoneOnly = async (payload: {
  shopSeqNo: number;
  phone: string;
  countryCode: string;
}) => {
  const response = await http.post<ApiEnvelope<LoginResponse>>('/users/signup/phone-only', payload);
  return response;
};

export const patchUser = async (customerId: number, payload: { name?: string }) => {
  const response = await http.patch<ApiEnvelope<unknown>>(
    `/users?customerId=${customerId}`,
    payload,
  );
  return response;
};
